import { render, staticRenderFns } from "./PlayerIndex.vue?vue&type=template&id=2d837d66&scoped=true&"
import script from "./PlayerIndex.vue?vue&type=script&lang=js&"
export * from "./PlayerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d837d66",
  null
  
)

export default component.exports